import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => {
  return {
    power: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      boxShadow: '0 -4px 22px 0 rgba(118, 117, 121, 0.15)',

      position: 'absolute',
      top: '16px',
      left: '16px',
      zIndex: 1,
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '5px 0',

      width: 100,
      justifyContent: 'center',

      '& svg': {
        '& ~ svg': {
          marginLeft: 6,
        },
      },
    },
    powerExclusive: {
      boxShadow: '0 -4px 22px 0 rgba(118, 117, 121, 0.15)',

      position: 'absolute',
      zIndex: 1,
      backgroundColor: '#fff',
      borderRadius: '50%',
      top: 54,
      left: 16,
    },
  };
});
